module.exports = __webpack_public_path__ + "img/kebijakan-kepmen.00bd0586.svg";